import React, { Component } from "react"
import HeaderNew from "../header/newheader";
import Banner from "../assets/Home/banner.png"
import research1 from "../assets/Home/research1.png"
import research2 from "../assets/Home/research2.png"
import research3 from "../assets/Home/research3.png"
import research4 from "../assets/Home/research4.png"
import project from "../assets/Home/project.png"
import grey from '../assets/grey.jpg'
import rightarrow from "../assets/Home/rightarrow.png"
import newSearch from "../assets/newHome/newSearch.png"
import downarrow from "../assets/newHome/chevron-down.png"
import carouselArrow from "../assets/newHome/right-arrow.png"

import "./typography.css"
import "./newHome.css"
import Footer from "../footer/newfooter";
import Slider from "react-slick";
import Axios from "axios";
import { BASE } from "../api/api";
import HtmlParser from "react-html-parser";
import { Link } from "react-router-dom";

const researchs = [
    { "icon": research1, "link": "/research/cluster", "name": "Research Clusters", "desc": "Focused domains of research to help CIS create knowledge and achieve excellence in the field of Islamic Studies." },
    { "icon": research2, "link": "/research/centers", "name": "Centers", "desc": "Well established centers to make CIS a leading voice in the field of Islamic Studies globally and attracts best talent." },
    { "icon": research3, "link": "/programs", "name": "Programs", "desc": "CIS curates contemporary, applied, multi-disciplinary and industry programs to provide an edge to its students. " },
    { "icon": research4, "link": "/cis_publication", "name": "Publications", "desc": "CIS continues to strive to a be pioneer in path breaking and industry leading research and be a guiding light to both Industry and Academia. " },
    { "icon": research4, "link": "/research/faculty", "name": "CIS Staff", "desc": "Bedrock of its success, the truly diverse CIS faculty not only reflects the global outlook of the institution, but are also amongst the finest academicians in their field." }
]


class NewHome extends Component {
    constructor(props) {
        super(props)
        this.state = {
            pubtype: "All"
        }
        this.hideIcon = this.hideIcon.bind(this);
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        Axios.get(BASE + 'jsonapi/node/submit_for_work?include=field_image,field_select_work_to_submit,field_author,field_image&filter[cis][condition][path]=field_cis_publications&filter[cis][condition][value]=1&filter[titleFilter][condition][path]=field_select_work_to_submit.name&filter[titleFilter][condition][operator]=IN&filter[titleFilter][condition][value][1]=Articles&filter[titleFilter][condition][value][2]=Books&filter[titleFilter][condition][value][3]=Book Chapters&filter[titleFilter][condition][value][4]=Conferences&page[limit]=12&page[offset]=0&sort=-field_year', {
            ttl: 300 /* seconds */,
        })
            .then((data) => {
                this.setState({
                    pub: data.data.data,
                    pubincluded: data.data.included
                })
            })
        // Axios.get(`${BASE}jsonapi/node/project?include=field_grant_authoritys,field_lead_project__investigator,field_projectinvestigator,field_projects_deliverable,field_research_cluster&page[offset]=0&page[limit]=10`, {
        //     ttl: 300 /* seconds */,
        // })
        //     .then((data) => {
        //         this.setState({
        //             projectsother: data.data.data,
        //             projectsincluded: data.data.included
        //         })
        //     })
        Axios.get(`${BASE}jsonapi/node/project?include=field_image_project&filter[field_project__status]=ongoing&page[limit]=12&page[offset]=0&sort=-field_project_start_date`, {
            ttl: 300 /* seconds */,
        })
            .then((data) => {
                this.setState({
                    projects: data.data.data,
                    projectsincluded: data.data.included
                })
            })
        let date = new Date(), curdate
        console.log("dates", date)
        Axios.get(`${BASE}jsonapi/node/events?include=field_image&sort[sort-author][path]=field_date&sort[sort-author][direction]=DESC&page[limit]=1&page[offset]=0`, {
            ttl: 300 /* seconds */,
        })
            .then((data) => {

                let upcoming = [], i
                this.setState({
                    event: data.data.data[0],
                    eventimage: data.data.included
                })
                if (data.data.data.length) {
                    let image = data.data.data[0].relationships.field_image.data ? data.data.included.filter(x => x.id === data.data.data[0].relationships.field_image.data.id)[0].attributes.uri.url : ""
                    this.setState({
                        imageofevent: image
                    })
                }
                console.log("upevents", upcoming)
            })
        Axios.get(`${BASE}jsonapi/node/events?include=field_image&sort[sort-author][path]=field_date&sort[sort-author][direction]=DESC`, {
            ttl: 300 /* seconds */,
        })
            .then((data) => {

                let upcoming = [], i
                for (i = 0; i < data.data.data.length; i++) {
                    curdate = new Date(data.data.data[i].attributes.field_date)
                    if (curdate.getTime() > date.getTime())
                        upcoming.push(data.data.data[i])
                }
                if (upcoming.length)
                    this.setState({
                        upevents: upcoming.reverse(),
                        mainevents: upcoming.reverse()[0],
                        upeventsincluded: data.data.included,
                    })
                else {
                    this.setState({
                        upevents: upcoming.reverse(),
                        mainevents: data.data.data.length ? data.data.data[0] : null,
                        upeventsincluded: data.data.included,
                    })
                }
                console.log("upevents", upcoming.reverse())
            })
    }


    hideIcon(e) {
        e.preventDefault();
        console.log(e.target.value);

        if (e.target.value) {
            document.getElementById('searchInput').classList.add("removeIcon")
        } else {
            document.getElementById('searchInput').classList.remove("removeIcon")
        }
    }
    _handleKeyPress(e) {

        if (e.key === 'Enter') {
            this.search()
        }
    }

    fillalert(msg) {
        this.setState({
            filltext: msg,
            fillalert: true
        })
        setTimeout(
            function () {
                this.setState({
                    fillalert: null
                })
            }
                .bind(this),
            3000
        );
    }


    search() {
        if (this.state.keyword.length < 3) {
            // alert("Enter atleast 3 characters")
            this.fillalert("Enter atleast 3 characters")

        }
        else {
            if (this.state.pubtype === "All")
                this.props.history.push('/search/' + this.state.keyword.replace(/\//g, '%20').replace(',', '%20'))
            else
                this.props.history.push('/search/' + this.state.keyword.replace(/\//g, '%20').replace(',', '%20') + `?type=${this.state.pubtype == "Theses" ? "Thesis" : this.state.pubtype}`)
        }
        // window.location.href = '/search/' + this.state.keyword.replace(/\//g, '%20').replace(',', '%20')
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    render() {
        const settings = {
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 3,
            autoplay: true,
            autoplaySpeed: 3000000,
            arrows: true,
            adaptiveHeight: false,
            prevArrow: <img src={carouselArrow} className="left-arrow" />,
            nextArrow: <img src={carouselArrow} />,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: false,
                        arrow: true,
                    },
                },
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: false,
                        arrow: true,
                    },
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                        arrow: true,
                    },
                },
            ]
        };
        return (
            <div id="nhome" className="nhome">
                {this.state.fillalert ? <div className="fill-alert">{this.state.filltext}</div> : ''}
                <HeaderNew />
                <div className="home-banner homeBanner" style={{ background: `url(${Banner}) no` }}>
                    <img src={Banner} />
                    <div className="homeBanner-subcontainer">
                        <h1 className="newHome-title">Islamic Bibliographic Info Repository</h1>
                        <p className="newHome-subText">I-BIR is a reference site providing access to research and publications of faculty, staff and students of College of Islamic Studies, Hamad Bin Khalifa University. In addition, it includes a dedicated bibliographic database on Islamic Economics and Finance.</p>
                        <div className="newHome-searchContainer d-flex">
                            <input className="newHome-searchInput" name="keyword" value={this.state.keyword} style={{ backgroundImage: `url(${newSearch})` }} id="searchInput" type="text" onChange={e => { this.handleChange(e); this.hideIcon(e) }} onKeyPress={(e) => this._handleKeyPress(e)} placeholder="Explore I-BIR" />
                            {

                                //    <div className="search-divider"></div>
                            }
                            <select value={this.state.pubtype} onChange={(e) => { this.setState({ pubtype: e.target.value }) }} className="mySelect" name="cate" id="cate" style={{ backgroundImage: `url(${downarrow})` }}>
                                <option value="All">All</option>
                                <option value="Articles">Articles</option>
                                <option value="Books">Books</option>
                                <option value="Book Chapters">Book Chapters</option>
                                <option value="Conferences">Conference Papers</option>
                                <option value="events">Events</option>
                                <option value="project">Projects</option>
                                <option value="Theses">Theses</option>
                            </select>
                            <button className="searchBtn" onClick={() => this.search()}>Search</button>
                        </div>
                    </div>
                </div>
                <div className="homeResearch container">
                    <div className="heading-two bold grey-text homeResearch-title">
                        I-BIR Research
                    </div>
                    <div className="rows justify-content-between">
                        {researchs ? researchs.map((item) => {
                            return (
                                <div className="research-card bg-dark-blue">
                                    <img src={item.icon} />
                                    <div className="d-flex spl-subContainer">
                                        {item.link ? <Link className="heading-four white-text bold" to={item.link} >{item.name}</Link> :
                                            <div className="heading-four white-text bold">{item.name}</div>
                                        }
                                        <p className="subtitle-two white-text">
                                            {item.desc}
                                        </p>
                                    </div>
                                </div>
                            )
                        }) : ""}
                    </div>
                </div>
                <div className="homePublication bg-blue">
                    <div className="container">
                        <div className="homePublication-title rows">
                            <div className="heading-two bold white-text">Latest Publications</div>
                            <Link to="/cis_publication" className="viewAll main-blue-text">View All</Link>
                        </div>
                        <div>
                            <Slider {...settings} className="newhome-slider" >
                                {
                                    this.state.pub ? this.state.pub.map(item => {
                                        let included = this.state.pubincluded
                                        let type = item.relationships.field_select_work_to_submit.data.id ? included.filter(x => x.id === item.relationships.field_select_work_to_submit.data.id)[0].attributes.name : ""
                                        let author = item.relationships.field_author.data.length ? included.filter(x => x.id === item.relationships.field_author.data[0].id)[0].attributes.title : ""
                                        let image = item.relationships.field_image.data ? included.filter(x => x.id === item.relationships.field_image.data.id)[0].attributes.uri.url : ""
                                        return (
                                            <div>
                                                <div className="publication-card bg-white">
                                                    <div className="newpub-button text-center">{type ? type : ""}</div>
                                                    <div className="rows">
                                                        <div>
                                                            <Link to={`/cis_publication/${item.attributes.title.replace(/\W+(?!$)/g, '-').replace(/\?/g, "-")}/${item.attributes.drupal_internal__nid}`} className="heading-three bold gray-text">
                                                                {item.attributes.title ? item.attributes.title : ""}
                                                            </Link>
                                                            <p className="body-two gray-text">
                                                                {item.attributes.body ? HtmlParser(item.attributes.body.value) : ""}
                                                            </p>
                                                            <p className="black-text body-two bold">{author ? author : ""}</p>
                                                        </div>
                                                        {image ? <img className="pub-img" src={BASE + image} /> : ""}
                                                    </div>

                                                </div>
                                            </div>
                                        )
                                    })
                                        : ""}
                            </Slider>
                        </div>
                    </div>
                </div>
                <div className="homeProjects bg-dark-blue">
                    <div className="container">
                        <div className="homePublication-title rows">
                            <div className="heading-two bold white-text">
                                Ongoing Projects
                            </div>
                            <Link to="/projects/ongoing" className="viewAll main-blue-text">View All</Link>
                        </div>
                        <div>
                            <Slider {...settings} className="newhome-slider newhome-slider2" >
                                {
                                    this.state.projects ? this.state.projects.map(item => {
                                        // field_image_project
                                        let included = this.state.projectsincluded
                                        let image = item.relationships.field_image_project.data ? included.filter(x => x.id === item.relationships.field_image_project.data.id)[0].attributes.uri.url : ""
                                        return (
                                            <div>
                                                <div className="publication-card home-pl-0">
                                                    <div className="image-container">
                                                        {image ? <img classname="card_Image" style={{ width: "100%" }} src={BASE + image} /> : <img src={grey} />}
                                                    </div>
                                                    <Link to={`/projectdetails/${item.attributes.drupal_internal__nid}`} className="heading-three bold white-text specialProjects-title" style={{ WebkitBoxOrient: 'vertical' }}>
                                                        {item.attributes.title ? item.attributes.title : ""}
                                                    </Link>
                                                    <p className="body-two white-text specialProjects-desc">
                                                        {item.attributes.body ? HtmlParser(item.attributes.body.value) : ""}
                                                    </p>
                                                    <Link to={`/projectdetails/${item.attributes.drupal_internal__nid}`} className="read-more subtitle-one white-text bold d-flex">
                                                        <span>Read More </span>
                                                        <img className="moreArrow" src={rightarrow} />
                                                    </Link>
                                                </div>
                                            </div>
                                        )
                                    })
                                        : ""}
                            </Slider>
                        </div>
                    </div>
                </div>
                <div className="homeResearch container">
                    <div className="heading-two bold grey-text homeResearch-title">
                        Events
                    </div>
                    <div className="rows newEvents-subcontainer justify-content-between">
                        {this.state.mainevents ? <div className="webinar-container">
                            <div className="position-relative">
                                <img className="eventsImage" src={this.state.mainevents.relationships.field_image.data ?
                                    this.state.upeventsincluded ? BASE + this.state.upeventsincluded.filter(x => x.id === this.state.mainevents.relationships.field_image.data.id)[0].attributes.uri.url
                                        : grey : grey} />
                                {/* <button className="newWebinar-button bold">Webinar</button> */}
                            </div>
                            {this.state.events}
                            <div className="event-card">
                                {<Link to={`/event_desc/${this.state.mainevents.attributes.title.replace(/\W+(?!$)/g, '-').replace(/\?/g, "-")}/${this.state.mainevents.attributes.drupal_internal__nid}`} className="heading-two bold white-text">
                                    {this.state.mainevents.attributes.title ? this.state.mainevents.attributes.title : ""}
                                </Link>}
                                <p className="body-two">
                                    {this.state.mainevents.attributes.body ? HtmlParser(this.state.mainevents.attributes.body.value) : ""}
                                </p>
                                {<Link to={`/event_desc/${this.state.mainevents.attributes.title.replace(/\W+(?!$)/g, '-').replace(/\?/g, "-")}/${this.state.mainevents.attributes.drupal_internal__nid}`} className="read-more cust-sub  subtitle-one white-text ">
                                    <span>Watch Now</span>
                                    <img src={rightarrow} />
                                </Link>}
                            </div>
                        </div>
                            : ""}
                        <div className="upcoming-container d-flex">

                            <div className="heading-three bold gray-text mb-2">
                                Upcoming Events
                            </div>

                            {this.state.upevents ? this.state.upevents.length ? this.state.upevents.map((event, ind) => {
                                let date = new Date(event.attributes.field_date)
                                let options = { year: 'numeric', month: 'short', day: 'numeric', weekday: 'long', };
                                date = date.toLocaleDateString("en-US", options)
                                let splits = date.split(",")
                                if (ind < 3)
                                    return (
                                        <div className="booking-blog">
                                            <Link to={`/event_desc/${event.attributes.title.replace(/\W+(?!$)/g, '-').replace(/\?/g, "-")}/${event.attributes.drupal_internal__nid}`} className="body-two gray-text">
                                                {event.attributes.title ? event.attributes.title : ""}
                                            </Link>
                                            <p className="body-three">
                                                {event.attributes.field_date ? `${splits[1]},${splits[2]} | ${splits[0]}` : ""}
                                                {/* Jan 12, 2022 | Wednesday */}
                                            </p>
                                            {/* <p className="events-book">Book Now</p> */}
                                        </div>
                                    )
                            }) : "No upcoming events" : ""}

                            <div className="d-flex eventButton-container">
                                <Link to="/events/upcoming" className="newEvents-button text-center bold">See All Events</Link>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
    }
} export default NewHome;